<template>
<section class="cta contact" id="contactus">
	<div class="container-fluid" style="text-align:center; background-color:#F5F5F5">
		<div class="row no-gutters">
			<div class="col-xs-6 col-md-6">
				<div class="cta-left">
					<img  src="/src/assets/img/seccion-desarrollamos.jpg" alt="">
				</div>
			</div>
			<div class="col-xs-6 col-md-6">
				<div class="cta_content-box">
					<div class="cta_desc">
						<h2 style="text-transform:initial;text-align:left">Desarrollamos campañas promocionales estratégicas y eficaces para tu marca<br></h2>
					</div>
				</div>
			</div>
		</div><br>
 
	<div class="container">
		<div class="row">
			<!-- Schedule column left starts -->
      <div class="col-xs-4 col-md-2">  </div>
			<div class="col-xs-8 col-md-8">
            <form @submit.prevent="submit">  
              <h3>Contáctanos</h3>
                <div class="row" style="text-align:center;">
                    <div class="form-group col-md-12">
                      <!-- <label for="email">Email *</label> -->
                            <input type="email" class="form-control" v-model.trim="email" placeholder="Escribe tu email">
                      </div><br>
                    <div class="form-group col-md-12">
                      <!-- <label for="message">Mensaje *</label> -->
                        <textarea rows="7" class="form-control" v-model.trim="message" placeholder="¿En qué podemos servirte?"></textarea>
                    </div>
                </div>
                <button type="submit" class="btn btn-default btn-primary">ENVIAR</button><br>
            </form> 
      </div>
       <div class="col-xs-4 col-md-2">  </div><br>
    </div>
   </div><br>
  <footer class="footer" style="background:white">
			<div class="container">
				<div class="row">
					<!-- COPY RIGHT -->
					<div class="col-md-6 offset-md-3">
						<ul class="list-inline socialLink text-center">
							<li class="list-inline-item"><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
							<li class="list-inline-item"><a href="#"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
							<li class="list-inline-item"><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
				
						</ul>
					</div>
					<div class="col-md-6 offset-md-3">
						<div class="copyRight_text text-center">
							<p>Americana de Negocios GC S.A. de C.V.</p>
						</div>
					</div>
				</div>
			</div>
		</footer>
 </div><br>
  
</section>
 
</template>

<script>
  import axios from 'axios'
  import { required, minLength, between, email } from 'vuelidate/lib/validators'
  export default {
    name: 'Contact',
    data() {
      return {
        email: null,
        message: null,
        submitStatus: null
      }
    },
    validations: {
      email: {
        required,
        email
      },
      message: {
        required
      }
    },
    mounted(){
      this.default()
    },
    methods: {
      default() {
        
      },
      setEmail(value) {
        this.email = value
        this.$v.email.$touch()
      },
      setMessage(value) {
        this.message = value
        this.$v.message.$touch()
      },
      submit() {
        debugger
        console.log('enviando...')
        var me = this
        this.$v.$touch()
        if (this.$v.$invalid) {
          this.submitStatus = 'ERROR'
          this.$swal('Error', 'Datos invalidos, revise su información', 'error');
        } else {
          // do your submit logic here
         me.submitStatus = 'PENDING'

        var json = {
          email: me.email,
          message: me.message,
        }
        this.$http.post('mail.php', {
          email: me.email,
          message: me.message,
        })
            .then(r => {
              console.log(r);
              me.$swal('Gracias', 'Su información ha sido enviada', 'success');
              me.submitStatus = null
              me.email = null
              me.message = null
            })
            .catch(e => {
              this.$swal('Error', 'Se provoco un error intente de nuevo', 'error');
              console.log(json)
              console.log(e)
              this.submitStatus = null
            })
        }
      }
    }
  }
</script>
<style>
.contenedor1 {
        display: table-cell;
        vertical-align: middle;
        text-align: center; /* requerido para alineación horizontal */
}
</style>



// WEBPACK FOOTER //
// src/components/contact/Contact.vue